import React from "react"
import styles from './index.module.css'
import DeviceName from "./DeviceName";
import BookmarkInfoButton from "./BookmarkInfoButton";

const TabPanel = (props) => {

    return (
        <div className={styles.tabPanel}>

            <div className={styles.headSection}>
                <div className={styles.space}></div>
                <DeviceName/>
                <BookmarkInfoButton/>
            </div>

            <div className={styles.bodySection}>
                {props.children} 
            </div>

        </div>
    )
}

export default TabPanel
